import {
  RBAC_TYPE_BRANDS,
  RBAC_TYPE_GROUPS,
  RBAC_TYPE_HOME,
  RBAC_TYPE_HOTELS,
  RBAC_TYPE_HOTEL_RESTAURANT,
  RBAC_TYPE_HOTEL_SYSTEMS,
  RBAC_TYPE_GRMS,
  RBAC_TYPE_ENTERTAINMENT,
  RBAC_TYPE_TEAMS,
  RBAC_TYPE_USERS,
  RBAC_TYPE_VENDOR_CONFIGS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
  RBAC_TYPE_HOTEL_AMENITIES,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
  RBAC_TYPE_HOTEL_SPA,
  RBAC_TYPE_DESIGN_CONFIGS,
  RBAC_TYPE_CMS_OFFERS,
  RBAC_TYPE_SERVICES_TELEPHONY,
  RBAC_TYPE_NOTIFICATIONS,
  RBAC_TYPE_HOTEL_LOCATION,
  RBAC_TYPE_CMS_TVCHANNELS,
  RBAC_TYPE_CMS_CITY_GUIDE,
  RBAC_TYPE_CMS_FEEDBACK,
  RBAC_TYPE_EMAIL_SERVICES,
  RBAC_TYPE_DASHBOARD_ACCOMODATION,
  RBAC_TYPE_DASHBOARD_IRD,
  RBAC_TYPE_DASHBOARD_RESTAURANT,
  RBAC_TYPE_DASHBOARD_SERVICE_REQUEST,
  RBAC_TYPE_DASHBOARD_SPA,
  RBAC_TYPE_DEVICE_MONITORING,
  RBAC_FNB_DASHBOARD_SPA,
  RBAC_TYPE_ANALYTICS,
  RBAC_TYPE_CHAT,
  RBAC_TYPE_CMS_ACTIVITYCALENDAR,
  RBAC_TYPE_APP_CONFIGURATIONS,
  RBAC_TYPE_STATISTICS,
  RBAC_TYPE_MESSAGES,
} from './RoleConsts';

export const CommonUtils = {
  getLeftMenu() {
    return [
      {
        title: 'Dashboard',
        permission: [
          RBAC_TYPE_DASHBOARD_ACCOMODATION,
          RBAC_TYPE_DASHBOARD_IRD,
          RBAC_TYPE_DASHBOARD_RESTAURANT,
          RBAC_TYPE_DASHBOARD_SERVICE_REQUEST,
          RBAC_TYPE_DASHBOARD_SPA,
          RBAC_FNB_DASHBOARD_SPA,
        ],
        icon: 'dashboard',
        route: '/',
      },
      {
        title: 'Properties',
        permission: [RBAC_TYPE_GROUPS, RBAC_TYPE_BRANDS, RBAC_TYPE_HOTELS],
        icon: 'apartment',
        route: '/properties',
      },
      {
        title: 'Hotel',
        permission: [
          RBAC_TYPE_HOTEL_RESTAURANT,
          RBAC_TYPE_HOTEL_SPA,
          RBAC_TYPE_HOTEL_ACCOMMODATIONS,
          RBAC_TYPE_HOTEL_AMENITIES,
          RBAC_TYPE_HOTEL_LOCATION,
        ],
        children: [
          {
            title: 'Restaurants',
            permission: [RBAC_TYPE_HOTEL_RESTAURANT],
            icon: 'restaurant',
            route: '/restaurant',
          },
          {
            title: 'Spa',
            permission: [RBAC_TYPE_HOTEL_SPA],
            icon: 'spa',
            route: '/spa',
          },
          {
            title: 'Accommodations',
            permission: [RBAC_TYPE_HOTEL_ACCOMMODATIONS],
            icon: 'king_bed',
            route: '/accomodations',
          },
          {
            title: 'Locations',
            permission: [RBAC_TYPE_HOTEL_LOCATION],
            icon: 'explore',
            route: '/location',
          },
          {
            title: 'Hotel Compendium',
            permission: [RBAC_TYPE_HOTEL_AMENITIES],
            icon: 'pool',
            route: '/amenities',
          },
        ],
        icon: 'location_on',
        route: '/hotels',
      },
      {
        title: 'Users & Teams',
        permission: [RBAC_TYPE_USERS, RBAC_TYPE_TEAMS],
        icon: 'person',
        route: '/users-and-teams',
      },
      {
        title: 'Analytics',
        permission: [RBAC_TYPE_ANALYTICS],
        icon: 'analytics',
        route: '/analytics',
      },
      {
        title: 'Services',
        permission: [RBAC_TYPE_SERVICES_IN_ROOM_DINING, RBAC_TYPE_SERVICES_SERVICE_REQUEST, RBAC_TYPE_SERVICES_TELEPHONY],
        children: [
          {
            title: 'Menu Config',
            permission: [RBAC_TYPE_SERVICES_IN_ROOM_DINING],
            icon: 'restaurant',
            route: '/in-room-dining',
          },
          {
            title: 'Service Requests',
            permission: [RBAC_TYPE_SERVICES_SERVICE_REQUEST],
            icon: 'room_service_black',
            route: '/service-request',
          },
          {
            title: 'Telephony',
            permission: [RBAC_TYPE_SERVICES_TELEPHONY],
            icon: 'call',
            route: '/telephony',
          },
        ],
        icon: 'dining',
        route: '/services',
      },
      {
        title: 'CMS',
        permission: [RBAC_TYPE_CMS_OFFERS, RBAC_TYPE_CMS_TVCHANNELS, RBAC_TYPE_CMS_FEEDBACK, RBAC_TYPE_CMS_CITY_GUIDE, RBAC_TYPE_CMS_ACTIVITYCALENDAR],
        children: [
          {
            title: 'Offers',
            permission: [RBAC_TYPE_CMS_OFFERS],
            icon: 'sell',
            route: '/offers',
          },
          {
            title: 'City Guide',
            permission: [RBAC_TYPE_CMS_CITY_GUIDE],
            icon: 'map',
            route: '/city-guide',
          },
          {
            title: 'Feedback',
            permission: [RBAC_TYPE_CMS_FEEDBACK],
            icon: 'thumb_up_alt',
            route: '/feedback-cms',
          },
          {
            title: 'TV Channels',
            permission: [RBAC_TYPE_CMS_TVCHANNELS],
            icon: 'tv',
            route: '/tvchannels',
          },
          {
            title: 'Activities',
            permission: [RBAC_TYPE_CMS_ACTIVITYCALENDAR],
            icon: 'date_range',
            route: '/activities',
          },
        ],
        icon: 'topic',
        route: '/cms',
      },
      {
        title: 'Campaign',
        permission: [RBAC_TYPE_NOTIFICATIONS, RBAC_TYPE_EMAIL_SERVICES, RBAC_TYPE_MESSAGES],
        children: [
          {
            title: 'Notifications',
            permission: [RBAC_TYPE_NOTIFICATIONS],
            icon: 'notifications_black_24dp',
            route: '/notifications',
          },
          {
            title: 'Email Services',
            permission: [RBAC_TYPE_EMAIL_SERVICES],
            icon: 'mail',
            route: '/email-services',
          },
          {
            title: 'Welcome Message',
            permission: [RBAC_TYPE_MESSAGES],
            icon: 'message',
            route: '/welcome-message',
          },
        ],
        icon: 'campaign_black_24dp',
        route: '/cms',
      },
      {
        title: 'Design Configs',
        permission: [RBAC_TYPE_DESIGN_CONFIGS],
        icon: 'view_quilt',
        route: '/ui-builder',
        checkHotelAccess: true,
        hotelCheckField: 'isUIBuilderEnabled',
      },
      {
        title: 'Configurations',
        permission: [
          RBAC_TYPE_HOTEL_SYSTEMS,
          RBAC_TYPE_GRMS,
          RBAC_TYPE_ENTERTAINMENT,
          RBAC_TYPE_VENDOR_CONFIGS,
          RBAC_TYPE_DEVICE_MONITORING,
        ],
        children: [
          {
            title: 'Hotel Services',
            permission: [RBAC_TYPE_HOTEL_SYSTEMS],
            icon: 'room_service_black',
            route: '/hotel-service',
          },
          {
            title: 'GRMS',
            permission: [RBAC_TYPE_GRMS],
            icon: 'fluorescent_outlined',
            route: '/guest-room-experience',
          },
          {
            title: 'Entertainment',
            permission: [RBAC_TYPE_ENTERTAINMENT],
            icon: 'smart_display',
            route: '/entertainment',
          },
          {
            title: 'Devices',
            permission: [RBAC_TYPE_DEVICE_MONITORING],
            icon: 'widgets',
            route: '/devices',
          },
          {
            title: 'App Configuration',
            permission: [RBAC_TYPE_APP_CONFIGURATIONS],
            icon: 'app_settings_alt',
            route: '/app-configuration',
          },
          // {
          //   title: 'Integrations',
          //   permission: [RBAC_TYPE_HOTEL_SYSTEMS],
          //   icon: 'integration_instructions',
          //   route: '/integrations'
          // },

          //will be needing as the relevant modules are integrated
          // {
          //   title: "Hotel Systems",
          //   permission: [RBAC_TYPE_HOTEL_SYSTEMS],
          //   icon: "folder",
          //   route: "/hotel-systems",
          // },

          {
            title: 'Vendor Configs',
            permission: [RBAC_TYPE_VENDOR_CONFIGS],
            icon: 'settings',
            route: '/vendor-config',
          },
        ],
        icon: 'settings',
        route: '/configurations',
      },
      {
        title: 'Chat',
        permission: [RBAC_TYPE_CHAT],
        icon: 'smsIcon',
        route: '/chat',
      },
    ];
  },
};

export const S3_TYPE = 'S3';
export const ACCESS_TOKEN = 'access_token';
export const USER = 'user';
export const LOGOUT = 'logout';
export const FTL_WALKTHROUGH_COMPLETED = 'first_time_logged_in_walkthrough_completed';
